import React from "react";
import classes from "./Competition.module.css";
import hero from "../../assets/images/competition-hero.png";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import CreateIcon from "@material-ui/icons/Create";
import PublishIcon from "@material-ui/icons/Publish";
import RedeemIcon from "@material-ui/icons/Redeem";
import Utils from "../../Utils";
import RegistrationForm from "./RegistrationForm";
import LevelSection from "./LevelSection";
import EmojiObjectsIcon from "@material-ui/icons/EmojiObjects";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CenterFocusStrongOutlinedIcon from "@material-ui/icons/CenterFocusStrongOutlined";
import ColorLensOutlinedIcon from "@material-ui/icons/ColorLensOutlined";
import AssignmentIcon from "@material-ui/icons/Assignment";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DateRangeIcon from "@material-ui/icons/DateRange";
import MenuBookIcon from "@material-ui/icons/MenuBook";

const rewards = [
  {
    icon: "🎮",
    title: "PlayStation 5",
    description: "",
  },
  {
    icon: "📱",
    title: "iPad 11",
    description: "",
  },
  {
    icon: "🎁",
    title: "Goodies & Hampers",
    description: "For all finalists",
  },
  {
    icon: "🏅",
    title: "Certificates",
    description: "For all participants",
  },
  {
    icon: "📚",
    title: "Published Book",
    description: "Amazon + Flipkart listing",
  },
  {
    icon: "🌟",
    title: "Wall of Fame",
    description: "Featured on our website",
  },
];

const judging = [
  {
    icon: EmojiObjectsIcon,
    title: "Creativity & Imagination",
    description: "Originality and creative expression",
  },
  {
    icon: AccountTreeOutlinedIcon,
    title: "Clarity of Thought",
    description: "Clear structure and organization",
  },
  {
    icon: EditOutlinedIcon,
    title: "Writing Style & Voice",
    description: "Unique voice and engaging style",
  },
  {
    icon: CenterFocusStrongOutlinedIcon,
    title: "Relevance to Topic",
    description: "Connection to chosen theme",
  },
  {
    icon: ColorLensOutlinedIcon,
    title: "Overall Presentation",
    description: "Design, layout and visual appeal",
  },
];

function Competition() {
  return (
    <div className={classes.main}>
      <section className={classes.heroSection}>
        <div className={classes.heroSectionBanner}>
          <img src={hero} alt={hero} />
        </div>
        <div className={classes.overlay} />
        <div className={classes.heroSectionContent}>
          <div className={classes.heroContentWrapper}>
            <div className={classes.heroBadge}>
              Become India's Next Young Author! 🌟
            </div>
            <h1 className={classes.heroTitle}>
              Star Author Book Writing Competition 2025
            </h1>
            <p className={classes.heroDescription}>Write. Publish. Win Big!</p>
            <div className={classes.rulesGrid}>
              <div className={classes.heroDetails}>
                <p>Important Dates</p>
                <div className={classes.dates}>
                  <div className={classes.date}>
                    <div>📅 Starts :</div>
                    <div>5 Sept 2025</div>
                  </div>
                  <div className={classes.date}>
                    <div>⏳ Submit by :</div>
                    <div>14 Nov 2025</div>
                  </div>
                  <div className={classes.date}>
                    <div>🏆 Results :</div>
                    <div>1 Dec 2025</div>
                  </div>
                </div>
              </div>
              <div className={classes.heroDetails}>
                <p>Winner's Rewards</p>
                <div className={classes.prizesGrid}>
                  <div className={classes.stepIcon}>🎮</div>
                  <div className={classes.stepIcon}>📱</div>
                  <div className={classes.stepIcon}>🎁</div>
                </div>
              </div>
            </div>
            <div className={classes.registrationButton}>
            <PrimaryButton>Register & Start Writing</PrimaryButton>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.stepsSection}>
        <div className={classes.container}>
          <h2 className={classes.stepsTitle}>3 Easy Steps to Shine!</h2>
          <div className={classes.steps}>
            <div className={classes.step}>
              <div className={classes.stepIcon}>
                <CreateIcon />
              </div>
              <h3>Write Your Story</h3>
              <p>
                Fiction or Non-Fiction, minimum 24 pages. Let your imagination
                soar!
              </p>
            </div>
            <div className={classes.step}>
              <div className={classes.stepIcon}>
                <PublishIcon />
              </div>
              <h3>Publish it on Bookalooza</h3>
              <p>
                Add your title, bio, and cover (templates available for
                everyone).
              </p>
            </div>
            <div className={classes.step}>
              <div className={classes.stepIcon}>
                <RedeemIcon />
              </div>
              <h3>Win & Get Published</h3>
              <p>Amazon + Flipkart listing, and get your own printed copy!</p>
            </div>
          </div>
        </div>
      </section>
      <LevelSection />
      <section className={classes.stepsSection}>
        <div className={classes.container}>
          <h2 className={classes.stepsTitle}>Judging Criteria</h2>
          <div className={classes.judgingGrid}>
            {judging.map((item, index) => (
              <div className={classes.step} key={index}>
                <div className={classes.stepIcon}>
                  <item.icon />
                </div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
        {/* <hr /> */}
        <div className={classes.container}>
          <h2 className={classes.stepsTitle}>General Rules & Guidelines</h2>
          <div className={classes.rulesContainer}>
            <div className={classes.rulesGrid}>
              <div>
                <div className={classes.topicsWrapper}>
                  <h3>
                    <AssignmentIcon /> Competition Details
                  </h3>
                  <div>
                    <ul>
                      <li>
                        <CheckCircleIcon />{" "}
                        <p>
                          <b>Eligibility:</b> Classes 3-12 (divided into 3
                          categories)
                        </p>
                      </li>
                      <li>
                        <CheckCircleIcon />{" "}
                        <p>
                          <b>Entry Fee:</b> ₹100 (fully refunded to Bookalooza
                          wallet after submission)
                        </p>
                      </li>
                      <li>
                        <CheckCircleIcon />{" "}
                        <p>
                          <b>Platform:</b>Directly publish on Bookalooza.
                          Auto-submitted for judging.
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={classes.topicsWrapper}>
                  <h3>
                    <DateRangeIcon /> Timeline
                  </h3>
                  <div>
                    <ul>
                      <li>
                        <CheckCircleIcon />{" "}
                        <p>
                          <b>Start Date:</b> 5 Sept 2025
                        </p>
                      </li>
                      <li>
                        <CheckCircleIcon />{" "}
                        <p>
                          <b>Last Date to Submit:</b> 14 Nov 2025
                        </p>
                      </li>
                      <li>
                        <CheckCircleIcon />{" "}
                        <p>
                          <b>Results Announcement:</b> 1 Dec 2025
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* Book Requirements */}
              <div className={classes.topicsWrapper}>
                <h3>
                  <MenuBookIcon /> Book Requirements
                </h3>
                <div>
                  <ul>
                    <li>
                      <CheckCircleIcon />{" "}
                      <p>
                        <b>Minimum 24 pages</b> (no word limit)
                      </p>
                    </li>
                    <li>
                      <CheckCircleIcon />{" "}
                      <p>
                        Must have <b>title, author bio, cover design</b>{" "}
                        (templates available)
                      </p>
                    </li>
                    <li>
                      <CheckCircleIcon />{" "}
                      <p>
                        <b>Original, age-appropriate content</b>
                      </p>
                    </li>
                    <li>
                      <CheckCircleIcon />{" "}
                      <p>
                        Can include{" "}
                        <b>
                          illustrations, poems, short stories, creative essays
                        </b>
                      </p>
                    </li>
                    <li>
                      <CheckCircleIcon />{" "}
                      <p>
                        Participants must choose{" "}
                        <b>one topic from Fiction or Non-Fiction</b> in their
                        category
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.levelSection}>
        <div className={classes.container}>
          <h2 className={classes.stepsTitle}>Every Author Wins!</h2>
          <div className={classes.steps}>
            {rewards.map((reward, index) => (
              <div className={classes.step} key={index}>
                <div
                  className={Utils.getClasses(
                    classes.stepIcon,
                    classes.pricesIcon
                  )}
                >
                  {reward.icon}
                </div>
                <h3>{reward.title}</h3>
                <p>{reward.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.stepsSection} id="registration">
        <div className={classes.container}>
          <h2 className={classes.stepsTitle}>Register Now!</h2>
          <RegistrationForm />
        </div>
      </section>
    </div>
  );
}

export default Competition;
